import { Link } from 'react-router-dom';
import PageFooter from '@/pages/home/components/PageFooter';
import FooterBG from "@/assets/footer_background.jpg";

const resources = [
  {
    icon: 'ri-tools-line',
    title: 'AI Starter Toolkit',
    desc: 'A curated collection of the best AI tools for SMEs and startups — ready to deploy from day one.',
    tag: 'Free with Registration',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Prompt Library',
    desc: 'Hundreds of battle-tested AI prompts for marketing, operations, customer service, and more.',
    tag: 'Free with Registration',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'AI Adoption Roadmap',
    desc: 'A step-by-step roadmap to guide your business through AI adoption — from beginner to advanced.',
    tag: 'Free with Registration',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    icon: 'ri-guide-line',
    title: 'AI Tools Guide',
    desc: 'Comprehensive guide covering the top AI tools, their use cases, pricing, and how to get started.',
    tag: 'Free with Registration',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    icon: 'ri-video-line',
    title: 'Replay Access',
    desc: 'Can\'t make it live? Get full replay access to all sessions so you never miss a single insight.',
    tag: 'Free with Registration',
    tagColor: 'bg-green-100 text-green-700',
  },
  {
    icon: 'ri-file-copy-2-line',
    title: 'Premium Templates',
    desc: 'Ready-to-use automation workflows, business templates, and AI implementation blueprints.',
    tag: 'Premium Only',
    tagColor: 'bg-amber-100 text-amber-700',
  },
];

const finalMessage = [
  'The future will not wait.',
  'AI is already transforming businesses.',
  'The question is: Will you lead or be left behind?',
];

const ResourcesSection = () => {
  return (
    <>
      

      {/* Final CTA Banner */}
      <section className="relative overflow-hidden bg-green-900">
        <img
          src={FooterBG}
          alt="Footer Background"
          className="absolute inset-0 w-full h-full object-cover object-top opacity-20"
        />
        <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-20 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-400/20 border border-amber-400/30 text-amber-300 text-xs font-semibold uppercase tracking-widest mb-8">
            <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
            Final Message
          </div>
          <div className="space-y-3 mb-10">
            <p className="font-bold leading-tight text-2xl md:text-3xl text-white/70">The future will not wait.</p>
            <p className="font-bold leading-tight text-2xl md:text-3xl text-white">AI is already transforming businesses.</p>
            <p className="font-bold leading-tight text-xl md:text-2xl bg-gradient-to-r from-amber-400 to-yellow-300 bg-clip-text text-transparent">
              The question is: Will you lead or be left behind?
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/register"
              className="px-8 py-4 rounded-full bg-gradient-to-r from-green-500 to-green-600 text-white font-bold text-base hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
            >
              Register Now — It's Free
            </Link>
            <Link
              to="/premium"
              className="px-8 py-4 rounded-full border-2 border-amber-400/50 text-amber-300 font-semibold text-base hover:bg-amber-400/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              Upgrade to Premium – $100
            </Link>
          </div>
          <p className="mt-6 text-white/40 text-sm italic">"Start small. Start now. Scale with AI."</p>
        </div>
      </section>

      <PageFooter />
    </>
  );
};

export default ResourcesSection;
